// frontend/src/components/ProfileBackground.js
import React, { useEffect, useState } from 'react';

const ProfileBackground = ({ imageData, interactive = true }) => {
  const [hovered, setHovered] = useState(false);
  const [pulseVisible, setPulseVisible] = useState(false);

  useEffect(() => {
    if (interactive) return undefined;

    const intervalId = window.setInterval(() => {
      setPulseVisible((prev) => !prev);
    }, 6000);

    return () => window.clearInterval(intervalId);
  }, [interactive]);

  // If no image, don't render anything or render default grey
  if (!imageData) {
    return null; // or just a grey div
  }

  const styles = {
    container: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 0, // Behind content which should be relative/z-index > 0
      pointerEvents: interactive ? 'auto' : 'none',
      backgroundColor: 'var(--bg-color)', // Theme-aware fallback
      overflow: 'hidden'
    },
    image: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      transition: 'opacity 2s ease-in-out',
      opacity: interactive ? (hovered ? 1 : 0.05) : (pulseVisible ? 0.3 : 0.08),
      filter: 'brightness(0.6) blur(2px)', // Always slightly darkened/blurred for readability
    }
  };

  return (
    <div
      style={styles.container}
      onMouseEnter={() => interactive && setHovered(true)}
      onMouseLeave={() => interactive && setHovered(false)}
    >
      <img src={imageData} alt="" style={styles.image} />
    </div>
  );
};

export default ProfileBackground;
